const { Cycler } = window.BAO

class SizeGuide extends window.BAO.CustomElement() {
  CURRENT_SIZE_ATTRIBUTE = 'current-size'
  ALLOWED_SIZES = ['in', 'cm']
  CLASSES = {
    in: 'drw-SizeGuide-in',
    cm: 'drw-SizeGuide-cm',
  }

  connectedCallback () {
    if (!this.els.trigger.element) {
      throw new Error(
        `<${this.localName}> needs an element with data-size-guide-el=trigger to work"`,
      )
    }

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.cycler = new Cycler(this.ALLOWED_SIZES)
    this.cycler.set(this.cycler.items.findIndex((i) => i === this.currentSize))

    this.els.trigger.element.addEventListener(
      'click',
      this.handleTriggerClick,
      {
        passive: true,
      },
    )

    this.handleTabClick = this.handleTabClick.bind(this)
    this.els.tab.elements.forEach((tab) => {
      this.listeners.add(tab, `click`, this.handleTabClick)
    })
  }

  disconnectedCallback () {
    this.els.trigger.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  handleTabClick (e) {
    const tab = e.target.closest(this.els.tab.selector)
    if (!tab) return

    const tabIndex = tab.dataset.index

    this.els.panel.elements.forEach((panel) =>
      panel.setAttribute(
        'aria-hidden',
        panel.dataset.index === tabIndex ? 'false' : 'true',
      ),
    )

    this.els.tab.elements.forEach((tab) =>
      tab.setAttribute(
        'aria-pressed',
        tab.dataset.index === tabIndex ? 'true' : 'false',
      ),
    )
  }

  async handleTriggerClick () {
    const currentSize = this.cycler.next()

    this.setCartAttribute(currentSize)
    this.currentSize = currentSize
    this.syncThemeSwitchers(currentSize)

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.THEME_SWITCH, {
      currentSize,
    })

    if (currentSize === 'cm') {
      this.els.integer.elements.forEach((integerEl) => {
        const cmValue = (integerEl.dataset.integer * 2.54).toFixed(1)
        integerEl.innerText = cmValue
      })
    } else {
      this.els.integer.elements.forEach((integerEl) => {
        const inValue = integerEl.dataset.integer
        integerEl.innerText = inValue
      })
    }
  }

  syncThemeSwitchers (currentSize) {
    this.allOtherThemeSwitches.forEach((el) => {
      el.currentSize = currentSize
      el.cycler.next()
    })
  }

  setCartAttribute (size) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_size: size,
        },
      }),
    })
  }

  get currentSize () {
    return (
      this.getAttribute(this.CURRENT_SIZE_ATTRIBUTE) || this.ALLOWED_SIZES[0]
    )
  }

  set currentSize (value) {
    this.setAttribute(this.CURRENT_SIZE_ATTRIBUTE, value)

    this.classList.toggle(this.CLASSES.in, value === 'in')
    this.classList.toggle(this.CLASSES.cm, value === 'cm')
  }

  get allOtherThemeSwitches () {
    // eslint-disable-next-line compat/compat
    return Array.from(document.querySelectorAll(this.localName)).filter(
      (el) => el !== this,
    )
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
